<script lang="ts" setup>
withDefaults(defineProps<{
  footerClass?: string
}>(), {
  footerClass: '',
})
</script>

<template>
  <div data-el="CoreAppFooterBlock" class="relative">
    <!--
      The wordmark sits *behind* the footer content (which has an opaque
      background) and is pinned to the bottom of the viewport with
      `position: sticky`. As the page scrolls, the content above slides up and
      uncovers the wordmark from underneath.

      Requirement: no ancestor between this element and the scroll container may
      be an overflow scroll container, or sticky is neutralised. The dashboard
      footer uses `overflow-x-clip` (not `hidden`) precisely so it clips
      horizontally without becoming a scroll container.
    -->
    <div class="relative z-1 bg-neutral-200">
      <div class="border-t border-default px-4 py-6 md:px-10 md:py-8">
        <CorePressStrip />
      </div>

      <div class="px-4 md:px-10 pb-10 border-t border-default">
        <div class="mx-auto w-full" :class="footerClass">
          <CoreMarketingFooter />
        </div>
      </div>
    </div>

    <img
      src="/images/home/forgd-wordmark.svg"
      alt="Forgd"
      aria-hidden="true"
      class="sticky bottom-0 z-0 mt-6 block h-auto w-full max-w-full select-none border-t border-default"
    >
  </div>
</template>
